import { customAxios, GENERIC_URL, IDUSUARIO, USERNAME } from '../constants';
import { FETCH_PROVEEDOR_LIST_ADDITIONAL_EQUIPMENT } from './types';
import { evalAction, serverError } from '../utils/actionError';

export function fetchProveedorEquposAdicionales(codProveedor, nombreProv, nroPag = '1') {

  const config = {
    headers: {
      idUsuario: IDUSUARIO,
      codUsuario: USERNAME,
      indPaginado: 'S',
      nroPag,
      cantidadxPag: '10',
    },

    params: {
      codProveedor: codProveedor.length ? codProveedor : null,
      nombreProv: nombreProv.length ? nombreProv : null,
    },
  };

  const request = customAxios.get(`${GENERIC_URL}/proveedor/listado`, config)
                                    .then(({ data }) => evalAction(data, 'listado'))
                                    .catch(error => serverError(error, 'listado'));

  return {
    type: FETCH_PROVEEDOR_LIST_ADDITIONAL_EQUIPMENT,
    payload: request,
  };
}



// WEBPACK FOOTER //
// ./src/actions/ProveedorEquiposAdicionales.js